import { Mail, MailOpen } from "lucide-react";

const EnvelopeIcon = ({
  size = 40,
  color = "black",
  opened,
}: {
  opened: boolean;
  size?: number;
  color?: string;
}) => {
  return opened ? (
    <MailOpen width={size} height={size} />
  ) : (
    <Mail width={size} height={size} style={{ color }} />
  );
};

export default EnvelopeIcon;
